var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-e8c25d18\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Resumo.vue")
}
var normalizeComponent = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Resumo.vue"
import __vue_script__ from "!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Resumo.vue"
/* template */
import __vue_template__ from "!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e8c25d18\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Resumo.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8c25d18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/screens/central/cadastros/para/permuta/components/Resumo.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e8c25d18", Component.options)
  } else {
    hotAPI.reload("data-v-e8c25d18", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/screens/central/cadastros/para/permuta/components/Resumo.vue
// module id = null
// module chunks = 